import { Injectable } from '@angular/core';
import { IState } from '../strategy-catalog.models';

@Injectable({ providedIn: 'root' })
export class StrategyCatalogStateService {
  state: IState = {
    activeTags: [],
    activeKpis: [],
    currentCategory: 'All',
    searchValue: '',
  };

  saveState(state: IState): void {
    this.state = state;
  }

  clear(): void {
    this.state.activeTags = [];
    this.state.activeKpis = [];
    this.state.currentCategory = 'All';
    this.state.searchValue = '';
  }

  hasState(): boolean {
    return (
      this.state.activeTags.length > 0 ||
      this.state.activeKpis.length > 0 ||
      this.state.currentCategory !== 'All' ||
      this.state.searchValue !== ''
    );
  }
}
